import React,{Component} from 'react';

import PropTypes from 'prop-types';

import LeftMenuListSty from './LeftMenuList.module.css';



class LeftMenuList extends Component{

    constructor(props){
        super(props);

    }



    render(){

        let itemSelectedSty={
            bgSty:{
                backgroundColor:'#181818',
            },
            fontSty:{
                color:'white',
                fontSize:'16px',
                fontFamily:'Microsoft YaHei',
                fontWeight:'bold',
                lineHeight:'16px',
            },
            iconSty:{
                color:'white',
                filter:`drop-shadow(${'white'},${0}px,${0}px)`
            },
        };
        let menuItems=null;
        if(this.props.leftMenuData!=undefined){
            menuItems=this.props.leftMenuData.map((item,index)=>{
                return (
                    <li key={index} onClick={()=>{this.props.onLeftMenuItemClick(index,item.id)}} style={this.props.menuItemSelectIndex == index? itemSelectedSty.bgSty: null}>
                        <div className={LeftMenuListSty.list_itemIconSty} style={{backgroundImage:`url()`}}></div>
                        <div className={LeftMenuListSty.list_itemNameSty} style={this.props.menuItemSelectIndex == index? itemSelectedSty.fontSty: null}>{item.title}</div>
                    </li>
                )
                
            });
        }

        return(
            <div className={`${LeftMenuListSty.listDiv} ${this.props.className}`}>
                <div className={LeftMenuListSty.listTitleSty}>{this.props.leftMenuTitle}</div>
                <ul>
                    {menuItems}
                </ul>
            </div>
        );
    }
}


LeftMenuList.propTypes={
    className:PropTypes.string,
    leftMenuTitle:PropTypes.string.isRequired,
    leftMenuData:PropTypes.array.isRequired,
    menuItemSelectIndex:PropTypes.number.isRequired,
    onLeftMenuItemClick:PropTypes.func.isRequired,
}


export default LeftMenuList;